import {Component, Input, ViewChild} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {Fluid} from "primeng/fluid";
import {Select} from "primeng/select";
import {Observable} from 'rxjs';
import {ManufacturerCollection} from '../../manufacturer/manufacturer-collection';
import {ManufacturerService} from '../../manufacturer/manufacturer.service';
import {Manufacturer} from '../../manufacturer/manufacturer';
import {FormsModule} from '@angular/forms';
import {PlanningParameterService} from '../../planning-parameter/planning-parameter.service';
import {PlanningParameter} from '../../planning-parameter/planning-parameter';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {Dialog} from 'primeng/dialog';
import {AutoComplete, AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from 'primeng/autocomplete';
import {ItemService} from '../../item/item.service';
import {Item} from '../../item/item';
import {PlanningParameterItemService} from '../../planning-parameter-item/planning-parameter-item.service';
import {IconComponent} from '../../components/app/layout/icon/icon.component';
import {InputText} from 'primeng/inputtext';

@Component({
  selector: 'app-planning-parameters',
    imports: [
        AsyncPipe,
        Fluid,
        Select,
        FormsModule,
        TableModule,
        Button,
        DatePipe,
        Dialog,
        AutoComplete,
        IconComponent,
        InputText,
    ],
  templateUrl: './planning-parameters.html',
  styleUrl: './planning-parameters.scss',
})
export class PlanningParameters {

    protected manufacturers$!: Observable<ManufacturerCollection>;
    protected selectedManufacturer!: Manufacturer;

    protected planningParameters: PlanningParameter[] = [];

    protected selectedPlanningParameter!: PlanningParameter;
    protected planningParameterName: string|null = null;
    protected showManageItemsModal: boolean = false;
    protected showCreateOrEditPlanningParameterModal: boolean = false;

    protected itemsAutocomplete: any[] = [];

    protected currentItems: Item[] = [];
    protected newItems: Item[] = [];

    @ViewChild('autoComplete') autoComplete!: AutoComplete;

    constructor(
        private manufacturerService: ManufacturerService,
        private planningParameterService: PlanningParameterService,
        private itemService: ItemService,
        private planningParameterItemService: PlanningParameterItemService
    ) {
    }

    ngOnInit(): void {
        this.manufacturers$ = this.manufacturerService.getAll();
    }

    protected manufacturerChanged(): void {
        if (this.selectedManufacturer) {
            this.planningParameterService.getAll(this.selectedManufacturer).subscribe(collection => {
                this.planningParameters = collection.getPlanningParameters();
            });
        } else {
            this.planningParameters = [];
        }
    }

    protected manufacturerCleared(): void {
    }

    protected manageItems(planningParameter: PlanningParameter): void {
        this.selectedPlanningParameter = planningParameter;

        if (planningParameter.items.length > 0) {
            this.itemService.findByIds(planningParameter.items).subscribe(itemCollection => {
                this.currentItems         = itemCollection.getItems();
                this.showManageItemsModal = true;
            })
        } else {
            this.currentItems         = [];
            this.showManageItemsModal = true;
        }
    }

    protected closeModal(): void {
        this.showManageItemsModal                   = false;
        this.showCreateOrEditPlanningParameterModal = false;
    }

    protected saveItems(): void {
        this.planningParameterItemService
            .update(this.selectedPlanningParameter, this.currentItems)
            .subscribe(ppItemCollection => {
                this.selectedPlanningParameter.items = ppItemCollection.getPlanningParameterItems();
                this.closeModal();
            });
    }

    protected searchItems(event: AutoCompleteCompleteEvent) {
        this.itemService.find(event.query).subscribe(itemCollection => {
            this.itemsAutocomplete = itemCollection.getItems();
        })
    }

    protected getItemLabel(item: Item): string {
        return `[${item.id}] - ${item.code}`;
    }

    protected itemSelected(event: AutoCompleteSelectEvent): void {
        const selectedItem: Item = event.value;

        this.newItems.push(selectedItem);
        this.currentItems.push(selectedItem);

        this.autoComplete.clear();
    }

    protected removeItemFromPlanningParameter(): void {
    }

    protected createNewPlanningParameter(): void {
        this.showCreateOrEditPlanningParameterModal = true;
    }

    protected canCreatePlanningParameter(): boolean {
        return this.selectedManufacturer !== null && this.selectedManufacturer !== undefined;
    }

    protected savePlanningParameter(): void {
        if (this.planningParameterName && this.planningParameterName.length > 0) {
            this.planningParameterService
                .create(this.planningParameterName, this.selectedManufacturer)
                .subscribe(newPlanningParameter => {
                    this.planningParameters.push(newPlanningParameter);
                    this.planningParameterName = null;
                    this.closeModal();
                });
        }
    }
}
